var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyordersDistributorsUprightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_30270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.73187 9.2675L9.2675 5.7325M9.2675 5.7325H6.17375M9.2675 5.7325V8.82625M7.5 13.75C10.9519 13.75 13.75 10.9519 13.75 7.5C13.75 4.04813 10.9519 1.25 7.5 1.25C4.04813 1.25 1.25 4.04813 1.25 7.5C1.25 10.9519 4.04813 13.75 7.5 13.75Z",
    stroke: "#5070DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_30270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyordersDistributorsUprightArrow);
export default __webpack_public_path__ + "static/media/myorders_distributors_upright_arrow.9e172e78e7506b9671e263849ed44dca.svg";
export { ForwardRef as ReactComponent };